import { render, staticRenderFns } from "./RefundDetailsModal.vue?vue&type=template&id=f66dce2a&scoped=true"
import script from "./RefundDetailsModal.vue?vue&type=script&lang=js"
export * from "./RefundDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./RefundDetailsModal.vue?vue&type=style&index=0&id=f66dce2a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66dce2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f66dce2a')) {
      api.createRecord('f66dce2a', component.options)
    } else {
      api.reload('f66dce2a', component.options)
    }
    module.hot.accept("./RefundDetailsModal.vue?vue&type=template&id=f66dce2a&scoped=true", function () {
      api.rerender('f66dce2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/customer-service/components/Modal/RefundDetailsModal.vue"
export default component.exports